import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface ConfirmModalData {
	title?: string;
	message: string;
	yesBtnText?: string;
	noBtnText?: string;
	isSwitchYesNo?: boolean; // Switch default yes/no buttons position
	hideNoBtn?: boolean;
}

@Component({
	selector: 'app-confirm-modal',
	templateUrl: './confirm-modal.component.html',
	styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

	public title: string;
	public message: string;
	public yesBtnText: string;
	public noBtnText: string;
	public isSwitchYesNo: boolean;
	public hideNoBtn: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ConfirmModalData,
		public dialogRef: MatDialogRef<ConfirmModalComponent>
	) { }

	ngOnInit() {
		this.title = this.data.title || 'Confirm';
		this.message = this.data.message;
		this.yesBtnText = this.data.yesBtnText || 'Yes';
		this.noBtnText = this.data.noBtnText || 'Cancel';
		this.isSwitchYesNo = this.data.isSwitchYesNo;
		this.hideNoBtn = this.data.hideNoBtn;
	}

}
